import { useMutation, useQuery } from "@tanstack/react-query"
import { enrollTraining, getAllTrainingCourses } from "../../apis/partner"

export const useFetchAllPartnerTraining = () => {
    return useQuery({
        queryKey: ['training-programs'],
        queryFn: () => getAllTrainingCourses(),
    })
}

export const useEnrollPartnerTraining = () => {
    return useMutation({
        mutationFn: ({partnerId, programId}) =>{ 
            console.log(partnerId, programId);
            
            return enrollTraining(partnerId, programId)},
        onSuccess:()=>{
            console.log("Successfully Enrolled!");
        },
        onError:(error)=>{
            console.log("Error Enrolling!", error);
            
        }
    })
}